import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class RolesAppService {
  private get roleId(): number | null {
    const raw = localStorage.getItem('user');
    if (!raw) return null;
    const id = Number(JSON.parse(raw)?.role_id);
    return isNaN(id) ? null : id;
  }

  get installerRole(): boolean {
    return this.roleId === 5;
  }

  get designerRole(): boolean {
    return this.roleId === 6;
  }

  get limitedRole(): boolean {
    return this.installerRole || this.designerRole;
  }

  get adminRole(): boolean {
    return this.roleId === 1 || this.roleId === 2;
  }
}
